import clsx from 'clsx';

import s from './Tile.module.scss';

export const Tile = ({
  children,
  onClick,
  className,
  style,
}: {
  children: React.ReactNode;
  onClick?(): void;
  className?: string;
  style?: React.CSSProperties;
}) => {
  return (
    <article
      className={clsx(s.Tile, className, onClick && s.clickable)}
      onClick={onClick}
      style={style}
    >
      {children}
    </article>
  );
};
